<template>
	<div>
		<div v-if="campaignData && campaignData.locationValue === '0'" class="container mgt-30">
			<a class="d-block" v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
				<img :src="campaignData.image" :alt="campaignData.dynamicLink.name" class="b-radius4">
			</a>
			<a v-else href="javascript:void(0)" style="cursor:none" class="d-block">
				<img :src="campaignData.image" alt="">
			</a>
		</div>
		<div class="container main-swiper-container"  >
			<!-- <mwc-linear-progress v-if="linearProgress" :indeterminate="linearProgress"></mwc-linear-progress> -->
			<NoData v-if="isNoData"></NoData>
			<div v-for="(data, index) in listData" :key="index" >

				<div v-if="campaignData && parseInt(campaignData.locationValue) === index+1 && data.degrees.length" class="mgt-30">
					<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank" class="d-block b-radius">
						<img :src="campaignData.image" class="round survey-banner">
					</a>
					<a v-else href="javascript:void(0)" class="d-block">
						<img :src="campaignData.image" class="round">
					</a>
				</div>


				<div class="d-flex justify-content-between align-items-baseline mgt-30 mgb-16" v-if="data.degrees.length>0">
					<div class="t-color-headlineBlack t-headline10 font-b">{{data.category.name}}</div>
					<div class="t-color-secondaryBtnText t-body2 font-m" v-if="data.degrees.length > 9" >
						<router-link tabindex="0" :to="`/degree/?type=ListCategory&id=${data.category.id}&name=${data.category.name}`" class="t-color-secondaryBtnText font-r">
							{{$t('869')}}
							<!-- 모두 보기 -->
						</router-link>
					</div>
				</div>
						
					<template v-if="data.degrees.length>0">
						<swiper :options="swiperOption" class="main-swiper pdx-4" ref="mySwiper">
							<swiper-slide class="" v-for="(degree, index2) in data.degrees" :key="index2" >            
								<CardItem1 :degree="degree"></CardItem1>
								<!-- <div class="swiper-slide"> -->
								<!-- </div> -->
							</swiper-slide>
							<!-- <swiper-slide class="d-flex" v-if="data.degrees.length >3">
								<router-link tabindex="0" :to="`/degree/?type=ListCategory&id=${data.category.id}&name=${data.category.name}`" class="d-flex w-full" >

									<div class="mdc-card   mdc-elevation--z3  w-full view-all-card">
										<div class="mdc-card__primary-action t-subtile3 t-color-primaryInactive t-center d-flex align-items-center h-full justify-content-center font-m"
											tabindex="0">

											{{$t('873')}}

										</div>
									</div>
								</router-link>
							</swiper-slide> -->
							<div class="swiper-button-prev custom-nav" slot="button-prev">
								<i class="material-icons t-color-iconActive font-22 rtl-support">arrow_back</i>
							</div>
							<div class="swiper-button-next  custom-nav r-3" slot="button-next">
								<i class="material-icons t-color-iconActive font-22 rtl-support">arrow_forward</i>
							</div>
						</swiper>
					</template>
			</div>
		</div>      
		 <infinite-loading @infinite="fetchData" spinner="spiral" style="visibility:hidden;"  >
				<div slot="no-more" class="pda-default">No more data</div>
				<div slot="no-results" class="pda-default"></div>
			</infinite-loading> 
	</div>
</template>

<script>
/**
 * 카테고리별 전체 차수 리스트 컴포넌트(Total category degree list Component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import InfiniteLoading from 'vue-infinite-loading'
import degreeApi from '@/api/degreeApi.js'
import campaignApi from '@/api/campaignApi.js'
import CardItem1 from './CardItem1.vue'
import NoData from '@/components/common/NoDataDegree.vue'
import '@material/mwc-linear-progress';

export default {
	props: ['listType'],
	components: {
		swiper,
		swiperSlide,
		CardItem1,
		NoData,
		InfiniteLoading
	},
	data() {
		return {
			swiperOption: {
				slidesPerView: 3,
				spaceBetween: 24,
				//slidesOffsetBefore: 16,
				//slidesOffsetAfter: 16,
				// pagination: {
				//     el: '.swiper-pagination',
				//     clickable: true
				// },
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				// translate: 0,
				// autoHeight: false
			},
			isNoData: false,

			campaignData: null,

			listData: [],
			currentPage: 1,
			totalPages: 1,
			linearProgress: true

		}
	},
	mounted(){
		this.setMaterialUi()
	},
	computed: {
		// swiper define
		swiper() {
			return this.$refs.mySwiper.swiper
		},
	},

	methods: {
		// 목록 데이터 호출(call api list data)
		fetchData($state) {
			this.$showLoading();
			let responseData = null
			let userIds = null
			let params = this.setParams()
			userIds = localStorage.getItem("token")
				if (this.totalPages >= this.currentPage) {
					degreeApi.learnOnlineCategoryList(params).then((response) => {
						responseData = response.data.data
						
						this.listData = this.listData.concat(responseData.content)
						this.currentPage++
						this.totalPages = responseData.totalPages
						
						let count = this.listData.reduce((val, itm) => itm.degrees.length > 0 ? val + 1 : val + 0, 0)

						//console.log(count)
						// let res = this.listData.filter(val => {
						//         return val.degrees.length
						//         //console.log(val.degrees)
						// })
						// console.log('123Hiii',res.length)
						if (responseData.content.length) {
							$state.loaded()
							this.$hideLoading();
						}else {
							this.$hideLoading();
							$state.complete()
						}

						if (!this.listData.length) {
							this.isNoData = true
						} else if(count==0) {
							this.isNoData = true
						}
						
					}).catch((err) => {
						this.$hideLoading();
						console.log('err=>',err)  
					})
				}else {
					
					$state.complete()
				}
		   
			// this.$showLoading(this.$refs.loading)
			// 캠페인 테이터 API 호출(call api campaign data)
			campaignApi.campaign({locationType: 'ALL_DEGREE'}).then((response) => {
				this.campaignData = response.data.data
			}).catch((err) => {})

			this.$hideLoading();
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				page: this.currentPage,
				size: 10,
				sort:'id,desc'
			}
			return params
		},
		setMaterialUi() {

			const selector = '.mdc-button, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			const buttonRipple = [].map.call(document.querySelectorAll(selector), function (el) {
				mdc.ripple.MDCRipple.attachTo(el);
			})
			var tabBar = new mdc.tabBar.MDCTabBar(document.querySelector('.mdc-tab-bar'));

		},
	}


}
</script>

<style scoped>
.mrg-cls{
	 margin-top: 120px;
}
.cl-height {
		margin-top: 120px;
}
 mwc-linear-progress {
	--mdc-theme-primary: var(--Mainbtn);
  }
</style>
